export const LOAD_REQUESTS = 'LOAD_REQUESTS';
export const CLEAR_REQUESTS = 'CLEAR_REQUESTS';
export const CHANGE_REQUESTS_LIST_OPTIONS = 'CHANGE_REQUESTS_LIST_OPTIONS';
export const CHANGE_REQUEST_STATUS = 'CHANGE_REQUEST_STATUS';
